import { company_name } from "@/i18n/variables";

const register = {
	// Section for domain collection card
	collection_card_section: {
		accept_domain_terms_and_conditions: {
			href: "https://www.tuxis.nl/voorwaarden-domeinnaam-registraties/",
			text: "By registering these domain names, I indicate that I have read and accept <a>the terms and conditions of the registrars</a>.",
		},
		delete_all: "Delete all",
		discount: "Your discount",
		edit: "Edit domain names",
		empty: {
			description: "Choose your desired domain name by performing a search.",
			title: "No domain names selected",
		},
		error: {
			dns_records_not_saved:
				"The DNS records have not yet been saved. Please save the DNS records in order to register.",
		},
		exc_vat: "Excl. VAT",
		price_trustee: "Price proxy",
		register: "Register domain names",
		title: "Selected domain names",
		total: "Total price",
	},

	// Complete section
	complete_section: {
		actions: {
			edit: "Edit",
			register: "Registration",
			transfer: "Transfer",
		},
		button_text: "To domain names",

		description: "The following domain names have been requested:",

		description_error:
			"Notice! Something went wrong while requesting registration/moving. \nThe following domains are affected:",
		dns: {
			failed: "DNS addition failed",
			success: "DNS added successfully",
		},
		info_alert:
			"Please note! This does not mean that your requested domains are already registered. You will receive an email from us when the request is final.",
		title: "Domain registration pending",
	},

	// DNS management section
	dns_management: {
		bttn_dns_fetch: "Fetch DNS",
		bttn_dns_select_template: "Select template",
		title: "Manage DNS",
	},

	// Domain holder section
	domain_holder_section: {
		description: "In order to register a new domain, some of your information is required.",
		local_presence: {
			alert: {
				accept_risk_button: "I have come to understand and accept the risks",
				description:
					"The following TLDs require local presence. This can be circumvented by using a proxy.",
				risk_button: "View the risks",
				risk_description:
					"By agreeing to use a proxy, you indicate that you know the risks and accept them.",

				// When any change is made to the text of risk_overview, then this change MUST also be made in the order confirmation email templates in the backend.
				risk_overview: `
### When using a proxy to register a domain name, there are several risks to consider:

- Local presence requirements are there for a reason. Circumventing these rules can lead to legal problems for both you and the proxy.
- There may be ambiguity as to who actually owns the domain name. In some cases, the trustee may technically be considered the owner, which can cause problems if you want to retain or change control of the domain name.
- You depend on the trustworthiness and integrity of the proxy. If this person or entity decides to abuse their position, it could lead to loss of the domain name or other related problems.
- Your domain name can be a crucial part of your online presence. By using a third party, you introduce an additional link where security issues can arise.
- Domain name renewal and management become more complicated. Communication and coordination with the trustee are necessary, which can lead to delays, misunderstandings and/or errors that can cause a domain name to be released.
- The ability to make changes or resolve problems related to the domain name may be limited because you are dependent on the cooperation and availability of the proxy.
- If the trustee becomes involved in illegal or unethical activities, your reputation may be adversely affected, especially if your domain name is associated with it.

### Tuxis shall not be liable in any way for direct, indirect or consequential damages in the use of a proxy to register a domain name.
`,
				risk_overview_title: "Risks of using a proxy",
				title: "Use proxy",
			},
			title: "Add proxy",
		},
		relation: {
			same_as_holder_error:
				"The selected relation is the current holder of this domain. Select another relation.",
			title: "Select relation",
		},
		relation_check: {
			title: "Data for verification",
		},
		title: "Choose domain holder",
		tld_requirements: {
			address: {
				description: "Additional address information is required for the following domains:",
				title: "Additional address information required!",
			},
			business_only: {
				description:
					"The following domain names can only be registered for business relations. Select another relation or delete the domain name.",
				title: "The following domains cannot be registered",
			},
			company: {
				company_private_relation:
					"Because you selected a private relation, you cannot complete this data. Select a business relation or remove the following domains from the list of domains to register (register later):",
				description: "Additional company information is required for the following domains:",
				title: "Additional company information required!",
			},
			personal_details: {
				description: "Additional personal data is required for the following domains:",
				title: "Additional personal data required!",
			},
			register_later_bttn: "Register later",
			remove_domain_bttn: "Delete domain",
			title:
				"Additional data required! These will be added to the selected relationship after registration.",
			trademark: {
				description: "The following domains require trademark information:",
				title: "Additional trademark information required!",
			},
		},
	},

	// Error messages
	error_messages: {
		transfer_domain:
			"An error occurred while transferring a domain. If the problem persists, please contact our customer service team.",
		update_relation_domain_details:
			"An error occurred while processing the relation's data. If the problem persists, please contact our customer service team.",
	},

	// Section for search results
	search_result_section: {
		domain_result_record: {
			available: "Available",
			months: "months",
			register: "Register",
			taken: "Taken",
			transfer: "Transfer",
			unavailable: "Not Available",
			unavailable_price: "Price not available",
		},
		title: "Found domain names",
	},

	// Section for searching domains
	search_section: {
		error_fetch_domain_purchase_info:
			"An error occurred while retrieving the domain extension information. If the problem persists, please contact our customer service team.",
		extension_unavailable: `This extension does not seem to exist. Would you like ${company_name} to contact you about registering this extension?`,
		extension_unavailable_bttn: "Send error message",
		extension_unavailable_bttn_success: "Error message sent successfully",
		oxxa_unavailable:
			"Please note! At this time, it is not possible to request domain status from the respective provider. Domain status may vary after registration.",
		search_alternative_tlds_placeholder: "e.g. '.com'",
		search_placeholder: `e.g. ${company_name}.com`,
		sending_extension_unavailable_mail_failed:
			"The error message could not be sent. Please try again later. If the problem persists, please contact our customer service team.",
		show_alternative_tlds: "More extensions",
		title: "Choose your domain name",
	},
	// Titles
	titles: {
		edit: "Edit domain name",
		register: "Register domain name",
	},

	transfer_token_section: {
		description:
			"You can request the transfer code from the party where your domain name is currently registered.",
		title: "Enter transfer code",
		token: "Transfer code",
	},
};

export default register;
